import { DefaultQueryParams, PaginatedResponse } from '@frontend/api-utils';
import { DateStep } from '@frontend/common';

export interface Report {
    delete_timestamp: string | null;
    name: string;
    name_nl_be: string | null;
    name_fr_fr: string | null;
    name_en_us: string | null;
    name_de_de: string | null;
    description: string | null;
    description_nl_be: string | null;
    description_fr_fr: string | null;
    description_en_us: string | null;
    description_de_de: string | null;
    period: DateStep;
    auto_generated: boolean;
    update_timestamp: string;
    type: ReportType;
    id: string;
    account_id: string;
    creation_timestamp: string;
}

export interface CreateReport {
    name?: string | null;
    name_nl_be?: string | null;
    name_fr_fr?: string | null;
    name_en_us?: string | null;
    name_de_de?: string | null;
    description_nl_be?: string | null;
    description_fr_fr?: string | null;
    description_en_us?: string | null;
    description_de_de?: string | null;
    description?: string | null;
    period?: DateStep | null;
    type?: ReportType | null;
}

export interface UpdateReport {
    null_fields?: string[] | null;
    name?: string | null;
    type?: ReportType;
    description?: string | null;
    period?: DateStep | null;
    name_nl_be?: string | null;
    name_fr_fr?: string | null;
    name_en_us?: string | null;
    name_de_de?: string | null;
    description_nl_be?: string | null;
    description_fr_fr?: string | null;
    description_en_us?: string | null;
    description_de_de?: string | null;
}

export enum QueryParams {
    name = 'name',
    type = 'type',
    account_id = 'account_id'
}

export enum ReportType {
    CATALOGUE_PRODUCTS = 'catalogue_products',
    LAUNDRY_INVENTORY_OWNER = 'laundry_inventory_owner',
    LAUNDRY_ITEMS_WASHED = 'laundry_items_washed',
    LAUNDRY_SHIPPING_BAGS_USED = 'laundry_shipping_bags_used',
    LAUNDRY_TRANSACTIONS = 'laundry_transactions',
    LENDING_CERTIFICATES = 'lending_certificates',
    LENDING_EQUIPMENT_CERTIFICATES = 'lending_equipment_certificates',
    LENDING_INVENTORY_EQUIPMENT = 'lending_inventory_equipment',
    LENDING_INVENTORY_PRODUCT = 'lending_inventory_product',
    LENDING_PRODUCT_CERTIFICATE_REQUIREMENTS = 'lending_product_certificate_requirements',
    LENDING_TAGS = 'lending_tags',
    LENDING_USER_CERTIFICATES = 'lending_user_certificates',
    LENDING_UTILIZATION_COMPLETED = 'lending_utilization_completed',
    LENDING_UTILIZATION_IN_USE = 'lending_utilization_in_use',
    MESSAGEBIRD_NOTIFICATIONS = 'messagebird_notifications',
    NIVALIZ_TRANSACTIONS = 'nivaliz_transactions',
    PUDO_COLLIS = 'pudo_collis',
    PUDO_TRANSACTIONS = 'pudo_transactions',
    USERS = 'users',
    BUDGET_USES = 'budget_uses',
    VENDING_CONSUMPTIONS = 'vending_consumptions',
    VENDING_RECYCLES = 'vending_recycles',
    VENDING_REPLENISHMENTS = 'vending_replenishments',
    VENDING_RETURNS = 'vending_returns',
    VENDING_STOCK = 'vending_stock',
    VENDING_STOCK_REPLENISHMENT = 'vending_stock_replenishment',
    VENDING_TRANSACTIONS = 'vending_transactions'
}

export type ReportQueryParams = DefaultQueryParams & QueryParams;
export type ReportListResponse = PaginatedResponse<Report>;
